import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetPayrollRunRequestSchema,
  TGetPayrollRunResponseSchema,
} from "./getPayrollRun.schema";

export const getPayrollRun = (axios: IAxiosInstance) => {
  return async (params: TGetPayrollRunRequestSchema) => {
    const { payrollRunID, ...rest } = params;

    const response = await axios.noRetry.get<
      IApiResponse<TGetPayrollRunResponseSchema>
    >(`/api/payroll-runs/${payrollRunID}`, {
      params: rest,
    });

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
